const applePayButtonStyles = {
	'.apple-pay-button': {
		'height': '48px',
		'border-radius': '8px',
	},
};

export { applePayButtonStyles };
